import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    :root {
        /* Light mode */
        --color-bg: #f3fbfc;
        --color-surface: #ffffff;
        --color-text: #073c46;
        --color-heading: #073c46;
        --color-primary: #0a5969;
        --color-primary-hover: #0f5c6c;
        --color-muted: #7da7af;
        --color-border: #d8e4e7;
        --color-input-bg: #eef6f7;
        --color-focus-ring: #0a5969;
    }

    body,
    html,
    a {
        font-family: 'Lato', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        position: relative;
        background: var(--color-bg);
        color: var(--color-text);
        overflow-x: hidden;
    }

    body::before {
        content: "";
        position: fixed;
        inset: 0;
        background-image: url("/img/svg/styling/background-contours.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        opacity: 0.04;
        pointer-events: none;
        z-index: 0;
    }

    /*
     * Sticky footer. Short pages - the thank-you page in particular - left the
     * footer floating mid-viewport with the page background showing beneath it.
     */
    #root {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        /* Mobile browsers size 100vh to the largest viewport, which overshoots
           while the address bar is showing. */
        min-height: 100dvh;
    }

    #root > main {
        flex: 1 0 auto;
    }

    a:hover {
        color: var(--color-primary-hover);
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: var(--color-input-bg);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;
        color: var(--color-text);

        :focus-within {
            background: none;
            box-shadow: var(--color-focus-ring) 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Lato', sans-serif;
        color: var(--color-heading);
        font-size: 56px;
        line-height: 1.18;
        font-weight: 700;
        text-transform: capitalize;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: var(--color-text);
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 700;
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--color-primary);

        :hover {
            color: var(--color-primary-hover);
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
